import { HttpClient } from '@angular/common/http';
import { inject, Service } from '@angular/core';
import { Observable } from 'rxjs';
import { RoleDto } from '@app/store/shared/models';
import { mapDto } from '@shared/operators';
import { ApiResponse } from '@shared/models';
import { GetRolesValue, GetRolesValueDto, RoleLookup, RoleLookupDto, Roles } from '../models';

@Service()
export class HttpService {
    private readonly httpClient = inject(HttpClient);

    getRoles(value: GetRolesValue): Observable<Roles> {
        const params = new GetRolesValueDto(value).toHttpParams();

        return this.httpClient.get<ApiResponse<RoleDto[]>>('v1/admin/roles', { params }).pipe(mapDto((response) => new Roles(response)));
    }

    getRolesLookup(): Observable<RoleLookup[]> {
        return this.httpClient
            .get<ApiResponse<RoleLookupDto[]>>('v1/admin/roles/lookup')
            .pipe(mapDto((response) => response.data.map((dto) => new RoleLookup(dto))));
    }
}
